import { render, staticRenderFns } from "./create-sl.vue?vue&type=template&id=24202e21&"
import script from "./create-sl.vue?vue&type=script&lang=js&"
export * from "./create-sl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports